// extracted by mini-css-extract-plugin
export var infoRow = "_uy-2";
export var labelContainer = "_uy-0";
export var rightInfo = "_uy-1";